import React from 'react';
import {Typography} from '~library/atoms/Typography';

export const Label = (props) => (
  <Typography variant="label2" classNames="view-invitation__label" data-qa-id={props['data-qa-id']}>
    {props.value}
  </Typography>
);
